import { Component, inject } from '@angular/core';
import { SidebarService } from '../../shared/services/sidebar.service';
import { SidebarUiService } from '../../shared/services/sidebar-ui.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-backdrop',
  imports: [CommonModule],
  templateUrl: './backdrop.component.html',
})
export class BackdropComponent {
  readonly ui = inject(SidebarUiService);
  readonly isMobileOpen$;

  constructor(private sidebarService: SidebarService) {
    this.isMobileOpen$ = this.sidebarService.isMobileOpen$;
  }

  closeSidebar() {
    this.sidebarService.setMobileOpen(false);
  }
}
